import { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/solid";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

export const AttendeeExperienceSection = () => {
  const [isAttendeeExperienceExpanded, setIsAttendeeExperienceExpanded] =
    useState(false);

  const toggleAttendeeExperience = () => {
    setIsAttendeeExperienceExpanded(!isAttendeeExperienceExpanded);
  };

  return (
    <div className="flex flex-col gap-4">
      <button
        type="button"
        onClick={toggleAttendeeExperience}
        className="hover:bg-secondary flex w-full items-center justify-between transition-colors"
      >
        <Typography.LabelSm weight="medium" color="text-primary">
          {t(
            "events.edit_modal.schedule_update_modal.attendee_experience_title",
          )}
        </Typography.LabelSm>
        {isAttendeeExperienceExpanded ? (
          <ChevronUpIcon className="size-5" />
        ) : (
          <ChevronDownIcon className="size-5" />
        )}
      </button>

      {isAttendeeExperienceExpanded && (
        <ul className="list-outside list-disc pl-4">
          <li>
            <Typography.LabelSm color="text-secondary">
              {t(
                "events.edit_modal.schedule_update_modal.attendee_experience_1",
              )}
            </Typography.LabelSm>
          </li>
          <li>
            <Typography.LabelSm color="text-secondary">
              {t(
                "events.edit_modal.schedule_update_modal.attendee_experience_2",
              )}
            </Typography.LabelSm>
          </li>
          <li>
            <Typography.LabelSm color="text-secondary">
              {t(
                "events.edit_modal.schedule_update_modal.attendee_experience_3",
              )}
            </Typography.LabelSm>
          </li>
          <li>
            <Typography.LabelSm color="text-secondary">
              {t(
                "events.edit_modal.schedule_update_modal.attendee_experience_4",
              )}
            </Typography.LabelSm>
          </li>
        </ul>
      )}
    </div>
  );
};
